export default "__VITE_ASSET__uWLjkAKC__"